import React from "react";
import Navbar from "../components/Navbar";
import useProgressiveImg from "../hooks/useProgressiveImg";
import scratchThumbnail from "../imgs/scratchThumbnail.png";

const LearnScratchPage = () => {
  const [
    scratchThumbnailSrc,
    { blur: scratchThumbnailBlur },
  ] = useProgressiveImg(
    "http://www.simpleimageresizer.com/_uploads/photos/88d05f0c/scratchThumbnail_1_1.png",
    scratchThumbnail
  );

  return (
    <div>
      <Navbar />
      <div className="py-24">
        <div className="container text-center">
          <p className="text-4xl md:text-5xl font-bold text-black">
            New to Scratch?
          </p>
          <p className="text-4xl md:text-5xl font-bold text-blue-500">
            We've got you.
          </p>
        </div>
      </div>
      <div className="py-16 md:py-24 bg-gray-50">
        <div className="container grid md:grid-cols-2 gap-6 items-center">
          <div className="space-y-3">
            <p className="text-3xl font-semibold">
              Our Best Videos,{" "}
              <span className="text-blue-500">Curated For You.</span>
            </p>
            <p className="font-medium text-gray-500">
              Check our our playlist of the best YouTube videos to get you
              started on your computer programming journey. We'll take you from
              a complete beginner to a full fledged computing machines in hours.
            </p>
          </div>

          <img
            className="w-full bg-gray-200 max-w-md cursor-pointer transform md:rotate-2 hover:rotate-3 hover:-translate-y-2 delay-150 rounded-md transition-all duration-500 ease-out shadow-xl hover:shadow-2xl"
            src={scratchThumbnailSrc}
            height={450}
            style={{
              filter: scratchThumbnailBlur ? "blur(10px)" : "none",
            }}
          />
        </div>
      </div>

      <div className="bg-gray-100 py-16 md:py-24">
        <div className="container space-y-3">
          <p className="text-center text-sm font-bold uppercase text-gray-400 tracking-wide">
            Press the <span className="underline">play</span> button.
          </p>
          <div className="flex justify-center">
            <iframe
              width="720"
              height="405"
              src={`https://www.youtube.com/embed/?listType=playlist&list=PLDbO_kJ9ZtGjlbKkg7nwEpx8wgx4F7BIy`}
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearnScratchPage;
